import { Form, Formik } from "formik";

import { Grid, Icon, Typography } from "@mui/material";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";

import FormField from "layouts/pages/users/new-user/components/FormField";

import { validationPeriodo } from "../schema/validationPeriodo";
import initialValuesPeriodo from "../schema/initialValuesPeriodo";
import fieldFormPeriodoInsc from "../schema/fieldFormPeriodoInsc";

interface Props {
  title?: string;
  description?: string;
  dateInitial: Date | string;
  dateEnd: Date | string;
  onChange: (startDate: Date | string, endDate: Date | string) => void;
}

export default function FormPeriodo({
  title,
  description,
  dateInitial,
  dateEnd,
  onChange,
}: Props) {
  const { startDate, endDay } = fieldFormPeriodoInsc;

  if (dateInitial === "" || dateEnd === "") return null;

  const dataForm = initialValuesPeriodo(dateInitial, dateEnd);

  return (
    <MDBox sx={{ px: { xs: 2, sm: 6 }, my: 1 }}>
      <MDBox sx={{ my: 2 }}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2" color="text">
          {description}
        </Typography>
      </MDBox>
      <MDBox>
        <Formik
          initialValues={dataForm}
          enableReinitialize
          validationSchema={validationPeriodo}
          onSubmit={(values) => {
            onChange(values.startDate, values.endDay);
          }}
        >
          {({ values, handleChange }) => {
            return (
              <Form>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={5}>
                    <FormField
                      type={startDate.type}
                      label={startDate.label}
                      name={startDate.name}
                      value={values[startDate.name]}
                      onChange={handleChange}
                      required
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <FormField
                      type={endDay.type}
                      label={endDay.label}
                      name={endDay.name}
                      value={values[endDay.name]}
                      onChange={handleChange}
                      required
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <MDButton
                      variant="gradient"
                      color="light"
                      fullWidth
                      type="submit"
                    >
                      <Icon>filter_alt_outlined</Icon>Filtrar
                    </MDButton>
                  </Grid>
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </MDBox>
    </MDBox>
  );
}
